
  import {
    Component,
    Model,
    Prop,
    Vue,
    Watch
  } from "vue-property-decorator";
  import Dialog from '@/components/dialog.vue';
  import {
    productInfo
  } from '@/api/supplier';

  @Component({
    name: 'refund-change-sku',
    components: {
      'slz-dialog': Dialog
    }
  })
  export default class RefundChangeSku extends Vue {
    @Model('change') isShow!: boolean;
    @Prop({}) private product_id!: number;
    @Prop({
      default: 0
    }) private sku_id!: number;
    private showDialog = false;
    private productInfo: any = null;
    private selectSkus: any = [];
    private selectSkuText: string[] = []

    @Watch('isShow')
    private onChangeShow(val: boolean) {
      this.showDialog = val;
      if (val) {
        this.getProductInfo()
      }
    }

    /**
     * @func choose sku_id
     * @param index current sku fater index
     * @param id current choose sku id
     * @param str current sku name
     */
    private chooseSkuId(index: number, id: number, str: string) {
      console.log(index, id ,str)
      this.$set(this.selectSkuText, index ,str);
      this.$set(this.selectSkus, index, id+'');
    }

    /**
     * @func close dialog
     */
    private handleClose() {
      this.productInfo = null;
      this.selectSkus = [];
      this.selectSkuText = [];
      this.$emit('change', false);
    }

    /**
     * @param get current product info
     */
    private async getProductInfo() {
      try {
        const res: any = await productInfo({
          product_id: this.product_id
        })
        this.productInfo = res.info
        this.selectSkus = new Array(res.info.sku_list.length).fill('');
        res.info.sku_list.map((item: any, index: number) => {
          this.selectSkus[index] = item.values[0].v_id + '';
          this.selectSkuText[index] = item.values[0].value;
        })
      } catch (e) {
        console.log(e)
      }
    }

    /**
     * @param return choose skuid
     */
    private confirm() {
      this.productInfo.sku_params.map((item: any) => {
        if (item.skus.sort().toString() == this.selectSkus.sort().toString()) {
          if (!item.amount) {
            this.$message({
              type: 'warning',
              message: '当前规格库存不足'
            })
          } else {
            this.$emit('confirm', {sku_id: item.sku_id, text: this.selectSkuText.join(';')})
            this.handleClose()
          }
        }
      })
    }
  }
